import axios from 'axios';
import getConfig from 'next/config';
import { getCookie } from './utils/cookieUtils';
const { publicRuntimeConfig } = getConfig();

// For common config
axios.defaults.headers.post['Content-Type'] = 'application/json';

const mainAxios = axios.create({
  baseURL: publicRuntimeConfig.BACKEND_ENPOINT,
});

const websiteUtilityAxios = axios.create({
  baseURL: publicRuntimeConfig.WEBSITE_UTILITY_ENDPOINT,
});

const websiteUtilityServerAxios = axios.create({
  baseURL: publicRuntimeConfig.WEBSITE_UTILITY_SERVER_ENDPOINT,
});

const mpBackendAxios = axios.create({
  baseURL: publicRuntimeConfig.MP_BACKEND_ENDPOINT,
});

const switchrAxios = axios.create({
  baseURL: publicRuntimeConfig.SWITCHR_ENDPOINT,
});

const cleartaxAxios = axios.create({
  baseURL: publicRuntimeConfig.CLEARTAX_DOMAIN,
});

const ksaAxios = axios.create({
  baseURL: publicRuntimeConfig.CLEARTAX_COM_DOMAIN,
});

const rewardAxios = axios.create({
  baseURL: publicRuntimeConfig.REWARD_API_ENDPOINT,
});

const cmsAxios = axios.create({
  baseURL: publicRuntimeConfig.CMS_ENDPOINT,
});

const ctaAxios = axios.create({
  baseURL: 'https://cleartax.in',
});
const quizAxios = axios.create({
  baseURL: publicRuntimeConfig.BEYOND_EVENT_QUIZ_QUESTION_ENDPOINT,
});

const clearTechAxios = axios.create({
  baseURL: 'https://www.clear.tech',
});

const copilotDocumentAxios = axios.create({
  baseURL: publicRuntimeConfig.DOCUMENT_UPLOAD_ENDPOINT,
});

const bifrostLayer = axios.create({
  baseURL: publicRuntimeConfig.CLEARTAX_DOMAIN,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'content-type': 'application/json',
  },
});

bifrostLayer.interceptors.request.use((config) => {
  if (typeof document !== 'undefined') {
    const sessionId = getCookie('sid');
    if (sessionId) {
      config.headers = config.headers || {};
      config.headers['sid'] = sessionId;
    }
  }
  return config;
});

export {
  bifrostLayer,
  clearTechAxios,
  cleartaxAxios,
  cmsAxios,
  ctaAxios,
  ksaAxios,
  mainAxios,
  mpBackendAxios,
  quizAxios,
  rewardAxios,
  websiteUtilityAxios,
  // eslint-disable-next-line prettier/prettier
  websiteUtilityServerAxios,
  switchrAxios,
  copilotDocumentAxios,
};
